import React, { useState, useEffect } from "react";
import { axios } from "../../utils/axios";
import { format } from "date-fns";
import TextBox from "../../components/textbox";
import DateSelector from "../../components/DateSelector";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import IMGNOFLIGT from "../../assets/images/trip/no-flight.png";
import Loader from "../../components/Loader/index";
import { toast } from "react-toastify";
const AddFlight = ({ tripId }) => {
  const [flightName, setFlightName] = useState();
  const [flightNumber, setFlightNumber] = useState();
  const [flightDate, setFlightDate] = useState(new Date());
  const [flightDetils, setFlightDetails] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getALlFlights();
  }, []);
  const flightDateChange = (val) => {
    setFlightDate(val);
  };
  const getALlFlights = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND + `trip/getallflights?tripid=${tripId}`
      )
      .then((resp) => {
        setFlightDetails(resp.data.data);
      })
      .catch((err) => console.log(err));
  };
  const addFlight = () => {
    if (flightDetils && flightName && flightDate) {
      setLoader(true);
      let data = {
        tripid: tripId,
        flightNumber: flightNumber,
        airlineCode: flightName,
        flightDate: format(new Date(flightDate), "yyyy-MM-dd"),
      };

      axios
        .post(process.env.REACT_APP_BACKEND + "trip/addflight", data)
        .then((resp) => {
          setFlightDetails(resp.data.data);
          setFlightNumber("");
          setFlightName("");
          setFlightDate(new Date());
          setLoader(false);
          toast.success("Flight Details added to the trip");
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    } else {
      toast.error("Please fill all the fileds");
    }
  };
  return (
    <>
      {loader && <Loader />}
      <div className="bxShadow cardcont p-4">
        <h3>Find a Flight</h3>
        <div className="d-flex align-items-end mt-3 f-wrap" style={{ gap: 10 }}>
          <div className="w100">
            <TextBox
              label="Airline Code"
              placeholder="AA"
              value={flightName}
              onChange={(e) => setFlightName(e.target.value)}
              fullWidth
            />
          </div>

          <div className="w100">
            <TextBox
              label="Flight Number"
              placeholder="6544"
              value={flightNumber}
              onChange={(e) => setFlightNumber(e.target.value)}
              fullWidth
            />
          </div>
          <div className="w100">
            <DateSelector
              label="Departure Date"
              onDateChange={flightDateChange}
              defaultDate={flightDate}
              placeholder="Select Date .."
            />
          </div>

          <button
            className="btn-contained d-flex align-items-center "
            onClick={addFlight}
          >
            {" "}
            <SearchIcon />
            Search
          </button>
        </div>
      </div>
      <div className="bxShadow cardcont p-4">
        <h3>Saved Flight Details</h3>
        {flightDetils && flightDetils.length !== 0 ? (
          flightDetils.map((fdata) => (
            <div className="bxShadow cardcont p-4 mt-4" key={fdata._id}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center " style={{ gap: 10 }}>
                  <p>{fdata?.departure?.city}</p>

                  <FlightTakeoffIcon />
                  <p>{fdata?.arrival?.city}</p>
                </div>
                <div>
                  <h3>
                    {fdata.airline} -{fdata.flightNumber}
                  </h3>
                  {/* <p className="-8">{fdata.name}</p> */}
                </div>
              </div>
              <hr className="my-2" />

              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <FlightTakeoffIcon />
                  <p className="-8">{fdata?.airlineName}</p>
                </div>
                <div className="ms-3">
                  {/* <p>{fdata?.arrival?.dateTime}</p> */}
                  <div className="d-flex align-items-center ">
                    <p className="me-2">{fdata?.departure?.airport}</p>
                    <ArrowForwardIcon />
                    <p className="ms-2">{fdata?.arrival?.airport}</p>
                  </div>
                </div>
                <div>
                  <div className=" align-items-center ">
                    <p> Departure: {fdata?.departure?.dateTime}</p>
                    {/* {""}
                    <p className="ms-3">Arr: </p>{" "} */}
                    <p> Arrival: {fdata?.arrival?.dateTime}</p>
                  </div>
                  <p>{fdata?.flightDuration}</p>
                </div>
                <p>Non-Stop</p>
              </div>
            </div>
          ))
        ) : (
          <div className="bxShadow cardcont p-4 mt-4 t-center">
            <img src={IMGNOFLIGT} className="w20" alt="" />
            <p>No Flight</p>
          </div>
        )}
      </div>
    </>
  );
};

export default AddFlight;
